import { formatDateInTimezone } from '../timezone/utils';
/** $1,234.56 — always two decimals; negative as -$1,234.56. */
export function formatUsd(n) {
    if (!Number.isFinite(n))
        return '—';
    const abs = Math.abs(n).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `${n < 0 ? '-' : ''}$${abs}`;
}
/** Credits: whole-number grouping, up to 2 decimals when fractional. */
export function formatCredits(n) {
    if (!Number.isFinite(n))
        return '—';
    return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}
/** Plain count with grouping. */
export function formatCount(n) {
    if (!Number.isFinite(n))
        return '—';
    return Math.round(n).toLocaleString('en-US');
}
/** +12.3% / -4.5% / 0.0% / N/A (null = previous window was zero). */
export function formatDeltaPct(deltaPct) {
    if (deltaPct === null)
        return 'N/A';
    if (deltaPct === undefined || !Number.isFinite(deltaPct))
        return '—';
    const sign = deltaPct > 0 ? '+' : '';
    return `${sign}${deltaPct.toFixed(1)}%`;
}
/**
 * Tone of the delta badge given the metric's semantics: for a cost metric
 * (goodWhen 'down'), an increase reads negative.
 */
export function deltaTone(deltaPct, goodWhen = 'up') {
    if (deltaPct === null || deltaPct === undefined || !Number.isFinite(deltaPct))
        return 'neutral';
    if (deltaPct === 0 || goodWhen === 'neutral')
        return 'neutral';
    const isUp = deltaPct > 0;
    const isGood = goodWhen === 'up' ? isUp : !isUp;
    return isGood ? 'positive' : 'negative';
}
/** Short day label for chart x-axis ticks: "2026-07-02" → "Jul 02, 2026". */
export function formatChartDay(day) {
    const d = new Date(`${day}T00:00:00Z`);
    if (Number.isNaN(d.getTime()))
        return day;
    return formatDateInTimezone(d, 'UTC');
}
/** Compact axis numbers: 1200 → "1.2K", 3400000 → "3.4M". */
export function formatCompact(n) {
    if (!Number.isFinite(n))
        return '';
    const abs = Math.abs(n);
    if (abs >= 1000000)
        return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    if (abs >= 1000)
        return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    return String(Math.round(n * 100) / 100);
}
